import styled from 'styled-components';
import { PlusCircle } from '@styled-icons/boxicons-regular/PlusCircle';

export const Container = styled.div`
  padding: 1rem 1.5rem;

  & .ant-table-cell {
    padding: 0.5rem;
  }

  & tr.ant-table-row {
    transition: opacity 0.5s;

    &.remove-item {
      opacity: 0;
    }
  }

  & .mdc-chip-set {
    flex-wrap: nowrap;
  }

  & svg {
    margin: 0;
  }

  & tr.ant-table-row[data-row-key='-1'] {
    & > td.ant-table-selection-column > label.ant-checkbox-wrapper {
      display: none;
    }
  }
`;

export const ButtonContainer = styled.div`
  & > button {
    width: 100%;
    align-items: center;
    margin: auto;
    margin-top: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const PlusCircleIcon = styled(PlusCircle)`
  width: 1rem;
  margin-right: 5px;
`;

export const MultiSelectDescription = styled.span`
  position: absolute;
  width: 16rem;
  top: 0.5rem;
  padding: 0.5rem;
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blue};
  z-index: 1;

  & > .right-arrow {
    position: absolute;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 6px solid ${({ theme }) => theme.colors.blue};
    top: 30%;
    left: 99%;
  }

  &.bounce-right {
    animation: bounceRight 2s infinite;
    @keyframes bounceRight {
      0%,
      20%,
      50%,
      80%,
      100% {
        -ms-transform: translateX(0);
        transform: translateX(0);
      }
      40% {
        -ms-transform: translateX(-16px);
        transform: translateX(-16px);
      }
      60% {
        -ms-transform: translateX(-8px);
        transform: translateX(-8px);
      }
    }
  }
`;
